export default {
  plan: {
    en: 'Plan',
  },
  order: {
    en: 'Order',
  },
  error: {
    en: 'ERROR',
  },
  ecommerceOrder: {
    en: 'Ecommerce Order',
  },
  subscriptionOrder: {
    en: 'Subscription Order',
  },
  subscriptionPlan: {
    en: '{billingPeriod, plural, one {One} other {#}}-Month Subscription',
  },
}
